import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-my-page-side-bar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './my-page-side-bar.component.html',
  styleUrl: './my-page-side-bar.component.scss',
})
export class MyPageSideBarComponent {
  router = inject(Router);
  route = inject(ActivatedRoute);
  url = signal<string>('');

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const urlSegments = this.router.url.split('/');
        this.url.set(urlSegments[urlSegments.length - 1]);
      });
  }
}
